import { useState, useEffect } from 'react';
import { PATHS } from '../constants';
import { getAssetUrl } from '../utils/assetUtils';

export const useBookData = (bookId) => {
  const [bookData, setBookData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookData = async () => {
      if (!bookId) {
        console.error('No bookId provided');
        setError('No book ID provided');
        setLoading(false);
        return;
      }

      const url = `${PATHS.BOOKS.BASE}/${PATHS.BOOKS.DATA[bookId]}`;
      console.log('Attempting to fetch book data from:', url);

      try {
        const response = await fetch(url);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Process data to update image paths
        processBookImagePaths(data);
        
        console.log('Successfully loaded book data');
        setBookData(data);
      } catch (error) {
        console.error('Fetch error:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBookData();
  }, [bookId]);

  // Function to process and update image paths in the book data
  const processBookImagePaths = (data) => {
    if (!data) return;
    
    // Process sections if they exist
    if (data.sections) {
      Object.values(data.sections).forEach(section => {
        if (section.content && section.content.image) {
          // Update image path to use CDN
          section.content.image = getAssetUrl(section.content.image);
        }
      });
    }
    
    // Process chapters if they exist
    if (data.chapters) {
      Object.values(data.chapters).forEach(chapter => {
        if (chapter.sections) {
          Object.values(chapter.sections).forEach(section => {
            if (section.content && section.content.image) {
              // Update image path to use CDN
              section.content.image = getAssetUrl(section.content.image);
            }
          });
        }
      });
    }
  };

  return { bookData, error, loading };
}; 